import { render } from "./Widget8.vue?vue&type=template&id=17490f48&ts=true"
import script from "./Widget8.vue?vue&type=script&lang=ts"
export * from "./Widget8.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__